interface Props {
  size?: number
  color?: string
  style?: React.CSSProperties
}

// Actual Stazon pictorial mark (oval O with rectangular end-caps, from brand SVG)
// Source: stazon-app/assets/logos/STAZON_Pictorial_Logo_*.svg — viewBox 0 0 48.19 70.87
export default function StationMark({ size = 16, color = '#C2E530', style }: Props) {
  const w = size * (48.19 / 70.87)
  return (
    <svg width={w} height={size} viewBox="0 0 48.19 70.87" style={style} aria-hidden="true">
      <path
        fill={color}
        d="M41.49,18.47c3.82,4.79,5.73,10.45,5.73,16.98s-1.91,12.32-5.73,17.04-9.62,7.08-17.4,7.08-13.58-2.36-17.4-7.08c-3.82-4.72-5.73-10.4-5.73-17.04s1.91-12.19,5.73-16.98c3.82-4.79,9.62-7.18,17.4-7.18s13.58,2.39,17.4,7.18ZM24.05,21.3c-3.46,0-6.12,1.23-7.99,3.67-1.87,2.45-2.8,5.94-2.8,10.48s.93,8.04,2.8,10.5c1.87,2.46,4.53,3.7,7.99,3.7s6.12-1.23,7.97-3.7,2.78-5.97,2.78-10.5-.93-8.03-2.78-10.48c-1.85-2.45-4.51-3.67-7.97-3.67Z"
      />
      <rect fill={color} x="18.16" y=".54" width="11.75" height="11.6" />
      <rect fill={color} x="18.16" y="58.86" width="11.75" height="11.47" />
    </svg>
  )
}
